export const SET_COUNTRIES = 'Set Countries'
export const SET_GLOBAL_WORKSPACE_TYPE = 'Set Global Type'
export const SET_GLOBAL_LOCATION = 'Set Global Location'
